import { getEnvVariable } from '@/utils';

export const API_ORIGIN = getEnvVariable('REACT_APP_API_ORIGIN')